import React from 'react';
import '../App.css'
import { Accordion } from './Accordion';

export default function WeeklyWeatherCard ({weatherData}){ 

  const date = weatherData.daily[0].dt * 1000

    const dayInMillis = 24*60*60*1000

    const weekDays =  Array(7).fill().map((x, index)=> index)
    .map((index) => new Date(date + (dayInMillis * index)));



      return (<div className="dropdown">
         <div className="dropdown-content">
         <div className="wrapper Amsterdam" id="third">
     { weekDays.map((date, index) => <Accordion key={index} followingDay={date} daily={weatherData.daily[index]} />)}
     </div></div></div>)
    }
